import type { Content, PageBreak, StyleDictionary } from 'pdfmake/interfaces';
import { MAGIC_SCALING_NUMBER, pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';
const fontSize = pdfTheme.font.size.default;
export class TitleBar implements BaseReportComponent {
	public height;
	private pageBreak: PageBreak | undefined;
	constructor(
		private collectionTitle: string,
		private jobName: string,
		private currentPoleIndex: number,
		private totalPoles: number,
		pageBreak?: PageBreak | 'none'
	) {
		// if the title wraps to a second line, this will break
		this.height = fontSize * MAGIC_SCALING_NUMBER + pdfTheme.spacing.default * 2;
		this.pageBreak = pageBreak === 'none' ? undefined : pageBreak;
	}

	exportContent(): Content {
		return {
			pageBreak: this.pageBreak,
			fillColor: pdfTheme.background.default,
			layout: {
				paddingTop: () => pdfTheme.spacing.default,
				paddingBottom: () => pdfTheme.spacing.default,
				paddingLeft: () => pdfTheme.spacing.default,
				paddingRight: () => pdfTheme.spacing.default,
				defaultBorder: false,
				hLineWidth: () => 0,
				vLineWidth: () => 0,
			},
			margin: [0, 0],
			// we use tables because it's the easiest way to get backgrounds that span the entire width
			table: {
				widths: ['auto', '*'],
				body: [
					[
						{ text: `Job: ${this.jobName}`, style: ['text', 'left'], margin: 0 },
						{
							text: `${this.collectionTitle} (${this.currentPoleIndex} of ${this.totalPoles})`,
							style: ['text', 'right'],
							margin: 0,
						},
					],
				],
			},
		};
	}

	exportStyles(): StyleDictionary {
		return {
			text: {
				fontSize,
				bold: true,
				color: pdfTheme.font.color.dark,
			},
			left: {
				alignment: 'left',
			},
			center: {
				alignment: 'center',
			},
			right: {
				alignment: 'right',
			},
		};
	}
}
